import { createAsyncThunk } from '@reduxjs/toolkit';

import UserService from '../../service/user.service';

export const getUserProfile = createAsyncThunk('user/getUserProfile', async (_, thunkAPI) => {
  try {
    const res = await UserService.getUserProfile();
    if (res?.data?.payload) {
      return res.data.payload;
    }
    throw Error('Auth: Empty response');
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
